export enum AppTypes {
  WebApp = 'Web',
  ElectronMacApp = 'Electron Mac',
  ElectronWinApp = 'Electron Win',
}

export type SuperProperties = {
  app_type: AppTypes;
};

export enum UserPropertiesKeys {
  WorkSituation = 'work_situation',
  HearAbout = 'how_did_you_hear_about_us',
}

export type UserProperties = Record<UserPropertiesKeys, string>;
